/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Index_No_ResourcesInputs */

const en_admin_resources_index_no_resources = /** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resources yet`)
};

const de_admin_resources_index_no_resources = /** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Ressourcen`)
};

const es_admin_resources_index_no_resources = /** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay recursos`)
};

const fr_admin_resources_index_no_resources = /** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune ressource pour l'instant`)
};

const nl_admin_resources_index_no_resources = /** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen voorzieningen`)
};

/** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */
const it_admin_resources_index_no_resources = en_admin_resources_index_no_resources;

/** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */
const pt_br2_admin_resources_index_no_resources = en_admin_resources_index_no_resources;

/** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */
const pl_admin_resources_index_no_resources = en_admin_resources_index_no_resources;

/** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */
const hu_admin_resources_index_no_resources = en_admin_resources_index_no_resources;

/** @type {(inputs: Admin_Resources_Index_No_ResourcesInputs) => LocalizedString} */
const ro_admin_resources_index_no_resources = en_admin_resources_index_no_resources;

/**
* | output |
* | --- |
* | "No resources yet" |
*
* @param {Admin_Resources_Index_No_ResourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_index_no_resources = /** @type {((inputs?: Admin_Resources_Index_No_ResourcesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Index_No_ResourcesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_index_no_resources(inputs)
	if (locale === "de") return de_admin_resources_index_no_resources(inputs)
	if (locale === "es") return es_admin_resources_index_no_resources(inputs)
	if (locale === "fr") return fr_admin_resources_index_no_resources(inputs)
	if (locale === "nl") return nl_admin_resources_index_no_resources(inputs)
	if (locale === "it") return it_admin_resources_index_no_resources(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_index_no_resources(inputs)
	if (locale === "pl") return pl_admin_resources_index_no_resources(inputs)
	if (locale === "hu") return hu_admin_resources_index_no_resources(inputs)
	return ro_admin_resources_index_no_resources(inputs)
});
export { admin_resources_index_no_resources as "admin.resources.index_no_resources" }